import { KountFraudCheckResultFragment, TransactionFragment } from '@occc/graphql';
import { Unstable_Grid2 as Grid } from '@mui/material';
import { InfoField } from '@occc-app/design-system';
import { TriggeredRulesInfo } from './TriggeredRulesInfo';
import { getMaskedCardNumber, shortenId } from '../utils';
import { getTransactionAddressWithLocationId } from '../TransactionView/utils';
import { labelByKountCheckStatus } from '../constants';

type TransactionFraudulentDetailsContentProps = {
  fraudCheckResult: KountFraudCheckResultFragment;
  transaction: TransactionFragment;
};

export const TransactionFraudulentDetailsContent = ({
  fraudCheckResult: checkResult,
  transaction,
}: TransactionFraudulentDetailsContentProps) => {
  return (
    <Grid container spacing={2}>
      <Grid xs={12} sm={4}>
        <InfoField label='Session ID' value={shortenId(checkResult.sessionId)} />
      </Grid>
      <Grid xs={12} sm={4}>
        <InfoField label='POS Transaction Number' value={transaction.posTransactionNumber} />
      </Grid>
      <Grid xs={12} sm={4}>
        <InfoField label='Member Phone Number' value={transaction.customer?.phoneNumber} />
      </Grid>

      <Grid xs={12} sm={4}>
        <InfoField label='Status' value={labelByKountCheckStatus[checkResult.status]} />
      </Grid>
      <Grid xs={12} sm={4}>
        <InfoField label='Omni Score' value={checkResult.omniScore} />
      </Grid>

      {checkResult.triggeredRules && (
        <Grid xs={12} sm={4}>
          <InfoField
            label='Triggered Rules'
            disableTypography
            value={
              checkResult.triggeredRules.length > 0 ? (
                <TriggeredRulesInfo rules={checkResult.triggeredRules} />
              ) : null
            }
          />
        </Grid>
      )}

      <Grid xs={12} sm={4}>
        <InfoField label='Card Type' value={checkResult.creditCardBrand} />
      </Grid>
      <Grid xs={12} sm={4}>
        <InfoField
          label='Card Number'
          value={getMaskedCardNumber(checkResult.binRange, checkResult.last4)}
        />
      </Grid>
      <Grid xs={12} sm={4}>
        <InfoField label='Auth Code' value={transaction.authCode} />
      </Grid>

      <Grid xs={12} sm={4}>
        <InfoField label='$Amount' value={`$${checkResult.amount}`} />
      </Grid>
      <Grid xs={12} sm={8}>
        <InfoField label='Location' value={getTransactionAddressWithLocationId(transaction)} />
      </Grid>
    </Grid>
  );
};
